import React from 'react';
import { useTranslation } from 'react-i18next';
import { ComponentProps } from '../config';
import IconWithToolTip from '../../../IconWithToolTip/IconWithToolTip';
import images from '../../../../images/images';

import './ApplicationTooltip.scss';

const ApplicationTooltip: React.FC<ComponentProps> = ({
  node,
  appDeploymentType,
}) => {
  const { t } = useTranslation('topologyTooltipApplication');

  const serviceCount =
    node?._references?.filter(
      reference => reference._edgeType === 'DEPL_HAS_SVCD'
    ).length ?? 0;

  const instanceCount =
    node?._references?.filter(
      reference => reference._edgeType === 'DEPL_HAS_INSTANCE'
    ).length ?? 0;

  const getHeaderTitle = () => {
    if (node?.is_discovered) {
      return (
        <div className='header'>
          <span className='header-title'>{node?.name}</span>
          <span className='page-title-icon'>
            <IconWithToolTip
              icon={images.AutoDiscoverdLockIcon()}
              iconDescription={t('autoDiscoveredAccessLimited')}
            />
          </span>
        </div>
      );
    }

    return (
      <div className='header'>
        <span className='header-title'>{node?.name}</span>
      </div>
    );
  };

  return (
    <div className='topology-tooltip-application'>
      {getHeaderTitle()}

      <div className='body'>
        <div className='label'>
          {t('type')} :{' '}
          {appDeploymentType ? t(`${appDeploymentType as string}`) : '-'}
        </div>
        <div className='label'>
          {t('services')} : {serviceCount}
        </div>
        <div className='label'>
          {t('instances')} : {instanceCount}
        </div>
      </div>
    </div>
  );
};

export default ApplicationTooltip;
